import { render, staticRenderFns } from "./QBResult.vue?vue&type=template&id=04a65f94"
import script from "./QBResult.vue?vue&type=script&lang=js"
export * from "./QBResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports